let css = require('./statistic.css');
let signals = require('../../../signals/account/statistic');
let Scrollable = require('./scrollable');
let ActionPanel = require('./action-panel');
const _ = require('lodash');
let $ = require('jquery');

class Statistic {
    constructor () {
        this.template = require('./template.hbs');
    }

    render () {
        return this.$context.getWatcherData().then((data) => {
            return Object.assign({}, data, { css });
        });
    }

    bind () {
        this.getStatisticChunk();

        let scrollable = document.getElementById('scrollable');
        // когда пользователь скроллит таблицу, запрашиваем новый кусок статистики
        scrollable.addEventListener('scroll', _.bind(_.debounce(this.getStatisticChunk, 50), this), false);
        // когда пользователь скроллит таблицу перемещаем хедеры таблицы, чтобы он их видел
        // это можно делать быстрее, чем запрашивать новые данные, чтобы не заствлять пользователя ждать
        scrollable.addEventListener('scroll', _.bind(_.debounce(this.updateHeaderPosition, 50), this), false);
        // при изменении зума обновляем размер сколящейся области
        window.addEventListener('resize', this.updateScrollableMaxHeight, false );
        this.isListenersInit = true;

        this.updateHeaderPosition();
        this.updateScrollableMaxHeight();
    }

    updateHeaderPosition () {
        let target = document.getElementById('scrollable');
        let topHeaderOffset = target.scrollTop;
        let headerLeftOffsetLeft = target.scrollLeft;
        this.$context.signal(signals.updateHeaderPosition, { topHeaderOffset, headerLeftOffsetLeft });
    }

    // максимальный размер прокручиваемой области подгоняем под размер окна браузера,
    // вычитаем хедер и нижнюю панель с кнопками
    updateScrollableMaxHeight () {
        let headerHeight = 80;
        let actionPanelHeight = 50;
        let scrollableMaxHeight = $(window).height() - headerHeight - actionPanelHeight;
        let scrollable = document.getElementById('scrollable');
        scrollable.style.maxHeight = scrollableMaxHeight + 'px';
        scrollable.style.minHeight = scrollableMaxHeight + 'px';
    }

    getStatisticChunk () {
        this.$context.signal(signals.getStatisticChunk);
    }
}

module.exports = {
    constructor: Statistic,
    children: [
        {
            name: 'scrollable',
            component: Scrollable,
            watcher: {
                orderId: ['account', 'statistic', 'orderId'],
                data: ['account', 'statistic', 'data'],
                topOffset: ['account', 'statistic', 'topOffset'],
                leftOffset: ['account', 'statistic', 'leftOffset'],
                headerTopOffset: ['account', 'statistic', 'header', 'topOffset'],
                headerLeftOffsetLeft: ['account', 'statistic', 'header', 'left', 'offset', 'left'],
                height: ['account', 'statistic', 'height'],
                width: ['account', 'statistic', 'width'],
                yStartIndex: ['account', 'statistic', 'yStartIndex']
            }
        },
        {
            name: 'action-panel',
            component: ActionPanel,
            watcher: {
                isByBranch: ['account', 'statistic', 'isByBranch'],
                downloadExcelLock: ['account', 'statistic', 'downloadExcelLock']
            }
        }
    ]
};



// WEBPACK FOOTER //
// ./components/account/statistic/index.js